export default __webpack_public_path__ + "static/media/my-quick-links.ac26bfdf.jpg";